export const getDynamicLabel = (label: string, chartWidth: number, numberOfBars: number) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (!context) return label;

  context.font = "12px Arial";
  const textWidth = context.measureText(label).width;

  const availableWidthPerBar = (chartWidth * 0.9) / numberOfBars;

  if (textWidth < availableWidthPerBar) {
    return label;
  }

  const ratio = availableWidthPerBar / textWidth;
  const allowedLength = Math.floor(label.length * ratio);

  return label.slice(0, Math.max(allowedLength - 3, 1)) + "...";
};

export const getTruncatedTooltipLabel = (label: string, chartWidth: number) => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return label;

  ctx.font = "12px Arial";
  const textWidth = ctx.measureText(label).width;
  const maxWidth = chartWidth * 0.9;

  if (textWidth <= maxWidth) {
    return label;
  }

  const ratio = maxWidth / textWidth;
  const allowedLength = Math.floor(label.length * ratio);
  return label.slice(0, Math.max(allowedLength - 3, 1)) + "...";
};
